import { render, staticRenderFns } from "./ConfigurazioneMedicoListComponent.vue?vue&type=template&id=8af5ba98"
import script from "./ConfigurazioneMedicoListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMedicoListComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneMedicoListComponent.vue?vue&type=style&index=0&id=8af5ba98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports